<template>
  <div>
    <navbar/>
    <error-panel showInPopup="false" />
    <Spinner :loaded="loaded" />
    <main role="main" v-if="loaded">
        <div class="jumbotron" id="tl-jumbotron">
          <div class="container">
            <div class="row tl-link-block tl-link-block-header pb-1 mb-3">

              <h4 class="col-12">
                <span class="bi bi-search tl-user-profile-icon mr-2 mb-3"></span>
                search my bookmarks
                <div class="input-group mb-3 mt-3 required">
                  <input type="text"
                         v-model="searchTerm"
                         placeholder="enter a keyword"
                         v-on:keyup.enter="onSearchStarted"
                         class="form-control" />
                  <button class="btn btn-success ml-2" type="submit" @click="onSearchStarted">
                    Search
                  </button>
                </div>
              </h4>
            </div>

          <div data-title="emptyState" v-if="searchComplete && !hasLinks" class="row tl-link-block p-4">
            <div class="col-sm-1 d-none d-sm-block">
                <i class="bi bi-emoji-astonished tl-emptystate-icon"></i>
            </div>
            <div class="col-sm-9 col-12">
              <div class="tl-link-title">
                  Couldn't find anything...
              </div>
              <div class="tl-link-small mt-3">
                  Could be a typo?
              </div>
            </div>
          </div>

          <LinkList v-if="hasLinks" :links="links" :owner="owner"/>
          </div>
        </div>
      </main>


    <tlfooter v-if="loaded"/>
  </div>
</template>

<script>
import BackendClient from "@/rest/backend-client";
import navbar from "@/components/NavBar";
import tlfooter from "@/components/Footer";
import ErrorPanel from "@/components/ErrorPanel";
import Spinner from "@/components/Spinner";
import LinkList from "@/components/LinkList";

export default {
  name: "Links",
  head: {
    title: 'just bookmark it! - search'
  },
  components: {
    ErrorPanel, navbar, tlfooter, Spinner, LinkList
  },
  props: ['owner'],
  data() {
    return {
      loaded: false,
      searchTerm: this.$route.query.searchTerm || "",
      searchComplete: false,
      links: null,
      backendClient: new BackendClient()
    }
  },
  mounted () {
    this.loaded = true;

    if (this.searchTerm && this.searchTerm !== '') {
      this.search();
    }
  },
  computed: {
    hasLinks() {
      return this.links && this.links.length > 0;
    }
  },
  methods: {
    onSearchStarted() {
      this.links = null;
      this.searchComplete = false;
      if (this.searchTerm !== this.$route.query.searchTerm) {
        this.navigate();
        return;
      } else {
        this.search();
      }
    },
    search() {
      this.backendClient.search(this.owner, this.searchTerm).then(responseData => {
        this.links = responseData.links;
        this.searchComplete = true;
      });
    },
    navigate() {
      this.$router.push({
        query: {
          ...this.$route.query,
          searchTerm: this.searchTerm || undefined
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
